import React from 'react';
import { MdStars } from 'react-icons/md';

import {
  Card,
  CardCloseButton,
  CardOptions,
  DetailList,
  Tippy,
} from '@/components';
import { InformationIcon } from '@/components/icons';
import { Maybe } from '@/globalTypes';
import formatMoney from '@/utils/formatter/formatMoney';

type RewardDetails = {
  currency: string;
  playerCurrentSegment: string | null;
  ngr: number | null;
  lastBonusAt: string | null;
  ngrSinceLastManualReward: number | null;
  lastBonusWasToday: boolean | null;
  isEligibleForReward: boolean | null;
  ineligibilityReasons?: string[] | null;
};

const IneligibilityReasonsTooltip = ({ reasons }: { reasons: string[] }) => (
  <Tippy
    content={
      <div className="max-w-xs">Failed condition: {reasons.join(', ')}</div>
    }
  >
    <span className="inline-flex items-center ml-1 cursor-pointer">
      <InformationIcon className="bg-grey-400 text-gray-500" />
    </span>
  </Tippy>
);

export const PlayerStats = ({
  rewardDetails,
}: {
  rewardDetails: Maybe<RewardDetails>;
}) => {
  const ineligibilityReasons = rewardDetails?.ineligibilityReasons ?? [];

  return (
    <Card
      size="lg"
      title="Player Stats"
      options={
        <CardOptions>
          <CardCloseButton />
        </CardOptions>
      }
    >
      <DetailList
        items={[
          {
            label: 'VIP Segment',
            value: rewardDetails?.playerCurrentSegment ? (
              <div className="flex items-center">
                <MdStars className="mr-1" />
                {rewardDetails.playerCurrentSegment}
              </div>
            ) : (
              '-'
            ),
          },
          {
            label: 'NGR',
            value: formatMoney(rewardDetails?.ngr, rewardDetails?.currency),
          },
          {
            label: 'NGR Since Last Manual Reward',
            value: formatMoney(
              rewardDetails?.ngrSinceLastManualReward,
              rewardDetails?.currency,
            ),
          },
          {
            label: 'Last Bonus At',
            value: rewardDetails?.lastBonusAt || '-',
          },
          {
            label: 'Any reward today?',
            value: rewardDetails?.lastBonusWasToday ? 'Yes' : 'No',
          },
          {
            label: 'Is player eligible for reward?',
            value: rewardDetails?.isEligibleForReward ? (
              'Yes'
            ) : (
              <div className="flex items-center">
                No
                {ineligibilityReasons.length > 0 && (
                  <IneligibilityReasonsTooltip reasons={ineligibilityReasons} />
                )}
              </div>
            ),
          },
        ]}
      />
    </Card>
  );
};
